import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCourses } from '../context/CourseContext';
import CourseCard from '../components/courses/CourseCard';
import { Search, Filter, Briefcase, Lightbulb, BookOpen, LineChart, Users, ChevronRight } from 'lucide-react';
const Courses: React.FC = () => {
  const {
    courses
  } = useCourses();
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState<'all' | 'required' | 'suggested' | 'optional'>('all');
  const filteredCourses = courses.filter(course => {
    const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase()) || course.description.toLowerCase().includes(searchTerm.toLowerCase());
    if (filter === 'all') return matchesSearch;
    if (filter === 'required') return matchesSearch && course.isRequired;
    if (filter === 'suggested') return matchesSearch && course.isSuggested;
    if (filter === 'optional') return matchesSearch && !course.isRequired && !course.isSuggested;
    return matchesSearch;
  });
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-883">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-884">
        <div className="text-center mb-12" data-id="element-885">
          <h1 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-886">
            Discover Modern Career Paths
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-887">
            Explore the diverse career opportunities available to education
            graduates beyond traditional classroom teaching.
          </p>
        </div>
        {/* Featured Course */}
        <div className="mb-12 bg-white rounded-lg shadow-md overflow-hidden" data-id="element-888">
          <div className="grid md:grid-cols-2" data-id="element-889">
            <div className="p-8" data-id="element-890">
              <div className="bg-blue-100 text-blue-800 text-xs font-medium inline-flex items-center px-2.5 py-0.5 rounded-full mb-4" data-id="element-891">
                Featured Course
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-892">
                From Teacher to Corporate Trainer and Educator
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-893">
                Discover how to leverage your education background to build a
                rewarding career in corporate training and development. This
                comprehensive course will guide you through the transition
                process and equip you with the skills needed to succeed.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-894">
                <li className="flex items-start" data-id="element-895">
                  <CheckIcon className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-896" />
                  <span className="text-gray-600" data-id="element-897">
                    Learn how to translate classroom skills to corporate
                    settings
                  </span>
                </li>
                <li className="flex items-start" data-id="element-898">
                  <CheckIcon className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-899" />
                  <span className="text-gray-600" data-id="element-900">
                    Master corporate training methodologies and technologies
                  </span>
                </li>
                <li className="flex items-start" data-id="element-901">
                  <CheckIcon className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-902" />
                  <span className="text-gray-600" data-id="element-903">
                    Build a compelling portfolio for corporate training roles
                  </span>
                </li>
              </ul>
              <Link to="/course-detail/corporate-trainer" className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-904">
                Start Learning
                <ChevronRight size={16} className="ml-1" data-id="element-905" />
              </Link>
            </div>
            <div className="hidden md:block" data-id="element-906">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k3yDfgNdb6Dg8WJ1RRfL8z/sfdfs.png" alt="Corporate training session" className="h-full w-full object-cover" data-id="element-907" />
            </div>
          </div>
        </div>
        {/* Career Path Categories */}
        <div className="mb-12 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-908">
          <div className="bg-white p-5 rounded-lg shadow-sm flex flex-col items-center" data-id="element-909">
            <Briefcase className="h-8 w-8 text-blue-600 mb-3" data-id="element-910" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-911">
              Corporate Training
            </h3>
            <button className="mt-3 px-3 py-1 bg-blue-600 text-white text-xs rounded-full" data-id="element-912">
              Available Now
            </button>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-sm flex flex-col items-center" data-id="element-913">
            <Lightbulb className="h-8 w-8 text-blue-600 mb-3" data-id="element-914" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-915">
              Instructional Design
            </h3>
            <button className="mt-3 px-3 py-1 bg-gray-500 text-white text-xs rounded-full" data-id="element-916">
              Coming Soon
            </button>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-sm flex flex-col items-center" data-id="element-917">
            <BookOpen className="h-8 w-8 text-blue-600 mb-3" data-id="element-918" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-919">
              Educational Technology
            </h3>
            <button className="mt-3 px-3 py-1 bg-gray-500 text-white text-xs rounded-full" data-id="element-920">
              Coming Soon
            </button>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-sm flex flex-col items-center" data-id="element-921">
            <Users className="h-8 w-8 text-blue-600 mb-3" data-id="element-922" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-923">
              HR Development
            </h3>
            <button className="mt-3 px-3 py-1 bg-gray-500 text-white text-xs rounded-full" data-id="element-924">
              Coming Soon
            </button>
          </div>
        </div>
        <div className="mb-8 flex flex-col md:flex-row justify-between gap-4" data-id="element-925">
          <div className="relative flex-grow max-w-3xl" data-id="element-926">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-927">
              <Search className="h-5 w-5 text-gray-400" data-id="element-928" />
            </div>
            <input type="text" placeholder="Search career paths..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:ring-blue-500 focus:border-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-929" />
          </div>
          <div className="flex items-center space-x-2" data-id="element-930">
            <Filter className="h-5 w-5 text-gray-400" data-id="element-931" />
            <select className="border border-gray-300 rounded-md py-2 pl-3 pr-8 focus:ring-blue-500 focus:border-blue-500" value={filter} onChange={e => setFilter(e.target.value as any)} data-id="element-932">
              <option value="all" data-id="element-933">All Paths</option>
              <option value="required" data-id="element-934">Core Paths</option>
              <option value="suggested" data-id="element-935">Suggested Paths</option>
              <option value="optional" data-id="element-936">Specialized Paths</option>
            </select>
          </div>
        </div>
        {filteredCourses.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-937">
            {filteredCourses.map(course => <CourseCard key={course.id} course={course} data-id="element-938" />)}
          </div> : <div className="text-center py-12" data-id="element-939">
            <p className="text-lg text-gray-600" data-id="element-940">
              No career paths found matching your search criteria.
            </p>
          </div>}
      </div>
    </div>;
};
// Simple check icon component
const CheckIcon = ({
  className
}: {
  className?: string;
}) => <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-941">
    <path d="M13.3334 4L6.00002 11.3333L2.66669 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-942" />
  </svg>;
export default Courses;